import {SourceType} from 'constants/SourceConstants';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {TableColumnType} from 'notebook/tables/constants/TableColumnConstants';
import {
  RegistrationTableCheckExistingBioentityRegisteredStatusCustomEvalQuery,
  ServerResolutionResult,
  StringResolutionType,
} from 'notebook/tables/string-resolution/StringResolutionConstants';
import * as RegistryUtil from 'registry/RegistryUtil';

import doBioentityQuery from './BioentityGQLQuery';
import {ALREADY_REGISTERED_ERROR} from './RegistrationStructuredTableAdapter';

export async function validateExistingBioentityNotRegistered(
  query: RegistrationTableCheckExistingBioentityRegisteredStatusCustomEvalQuery
): Promise<ServerResolutionResult> {
  const {bioentityId, columnDefinition, typedValue} = query;
  const customSyntaxName =
    columnDefinition.type === TableColumnType.BASES
      ? columnDefinition.basesColumnConfig.customSyntaxName
      : undefined;
  const data = await doBioentityQuery(bioentityId, customSyntaxName);
  const bioentitySummary = data.directBioentity;
  if (isInaccessible(bioentitySummary)) {
    return {
      type: StringResolutionType.CUSTOM,
      error: 'You do not have permission to register the entity.',
      resolvedValue: {typedValue},
    };
  }

  if (
    RegistryUtil.isRegistryFolder({
      source: {
        id: bioentitySummary.folder.source.id,
        sourceType: bioentitySummary.folder.source.sourceType as SourceType,
        archived: bioentitySummary.folder.source.archived,
        archiveRecord: bioentitySummary.folder.source.archiveRecord,
        hidden: bioentitySummary.folder.source.hidden,
        starred: bioentitySummary.folder.source.starred,
      },
    })
  ) {
    return {
      type: StringResolutionType.CUSTOM,
      error: ALREADY_REGISTERED_ERROR,
      resolvedValue: {typedValue},
    };
  }

  return {
    type: StringResolutionType.CUSTOM,
    error: null,
    resolvedValue: {typedValue},
  };
}
